export default __webpack_public_path__ + "static/media/work-day.0011d06a.png";